import {useCanGoBackCallback, useHistory} from '@aboutyou/router';
import {BackButton} from '@aboutyou/ui-components';
import React, {ComponentProps, FC, useMemo} from 'react';

export const GoBackButton: FC<
  ComponentProps<typeof BackButton> & {className?: string}
> = props => {
  const canGoBackCallback = useCanGoBackCallback();
  const canGoBack = useMemo(() => canGoBackCallback(), []);
  const {goBack} = useHistory();

  if (!canGoBack) {
    return null;
  }

  const handleGoBack = () => {
    if (canGoBackCallback()) {
      goBack();
    }
  };

  return (
    <BackButton className={props.className} onClick={handleGoBack} {...props} />
  );
};
